// imports
import React from 'react';
import AccountHeader from './header';
import { IActionItem } from '../../common/types';

// interfaces / types / consts
interface Props {
  children: JSX.Element | JSX.Element[];
  navItems?: IActionItem[];
}

// exports
export default function AccountLayout(props: Props): JSX.Element {
  const { children, navItems } = props;
  // render
  return (
    <div className="account-layout">
      <AccountHeader navItems={navItems} />
      {children}
    </div>
  );
}

AccountLayout.defaultProps = { navItems: [] };
